import { render, staticRenderFns } from "./Santen.vue?vue&type=template&id=7414803c&scoped=true"
import script from "./Santen.vue?vue&type=script&lang=js"
export * from "./Santen.vue?vue&type=script&lang=js"
import style0 from "./Santen.vue?vue&type=style&index=0&id=7414803c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7414803c",
  null
  
)

export default component.exports